module.exports = __webpack_public_path__ + "img/31.2a72e407.jpg";